import { makeStyles } from '@material-ui/core';
import colors from '@danfoss/webex-ui/dist/styles/_colors.scss';

export const useStyles = makeStyles(theme => ({
  field: {
    maxWidth: 320,
    marginBottom: 5,
    '& input': {
      color: colors.webexuiBlack,
    }
  },
}));
